"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var userConfigurationDictionaryEntry_1 = require("owa-service/lib/factory/userConfigurationDictionaryEntry");
var userConfigurationDictionaryObject_1 = require("owa-service/lib/factory/userConfigurationDictionaryObject");
var updateUserConfiguration_1 = require("owa-session-store/lib/services/updateUserConfiguration");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
function selectNewCalendar(newSelectedCalendarId) {
    var selectedCalendarsViewState = getUserConfiguration_1.default().ViewStateConfiguration
        .SelectedCalendarsDesktop;
    if (selectedCalendarsViewState &&
        selectedCalendarsViewState.indexOf(newSelectedCalendarId) < 0) {
        selectedCalendarsViewState.push(newSelectedCalendarId);
    }
    return updateUserConfiguration_1.default('OWA.ViewStateConfiguration', [
        userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: ['SelectedCalendarsDesktop'],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: 'StringArray',
                Value: selectedCalendarsViewState,
            }),
        }),
    ]).then(function (response) {
        var responseItem = response.Body.ResponseMessages.Items[0];
        if (responseItem.ResponseClass == 'Success') {
            return Promise.resolve();
        }
        else {
            return Promise.reject('updateUserConfiguration failed: ' + responseItem.ResponseClass);
        }
    });
}
exports.default = selectNewCalendar;
//# sourceMappingURL=selectNewCalendar.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-sharing-accept/lib/services/selectNewCalendar.js
// module id = 5808
// module chunks = 96